// An org's YouTube link has two failure modes the UI must tell apart: never linked (no channel
// name), and linked-but-dead — Google refused the stored refresh token, so the backend answers
// every broadcast call on that org's behalf with a 409 until someone reconnects the channel on
// the Integrations page. `youTubeNeedsReauthorization` rides along on the org details payload.
export const youtubeNeedsReauthorization = (selectedOrg) =>
  Boolean(selectedOrg?.youTubeChannelName) && Boolean(selectedOrg?.youTubeNeedsReauthorization)

// Whether an event form may offer the org's own YouTube channel as a broadcast destination.
// A dead link withdraws the option for NEW broadcasts, but an event that already streams to
// YouTube keeps it: the initial-values helpers null `eventYtConfig` whenever the option is
// unavailable, so withdrawing it there would wipe the saved config on the next save.
export const canUseOrgYoutube = (selectedOrg, broadcastId) =>
  Boolean(selectedOrg?.youTubeChannelName) &&
  (!youtubeNeedsReauthorization(selectedOrg) || Boolean(broadcastId))
